import { sleep } from '@/util'
import { defaultApi } from '@/plugins/api/defaultApi'
import { defaultV2Api } from '@/plugins/api/defaultV2Api'
import logo404Path from '@/assets/images/fashion.png'

let getMallsLoading = false

const getMallsLoadingCheck = async () => {
  if (getMallsLoading === false) {
    return true
  }
  await sleep(10)
  return getMallsLoadingCheck()
}

let getMallsProvidersLoading = false

const getMallsProvidersLoadingCheck = async () => {
  if (getMallsProvidersLoading === false) {
    return true
  }
  await sleep(10)
  return getMallsProvidersLoadingCheck()
}

export default {
  name: 'mall',
  namespaced: true,
  state: {
    isMallsLoad: false,
    malls: null,
    providers: null,
  },
  getters: {
    isMallsAvailable(state) {
      if (!state.malls) {
        return false
      }
      return state.malls.length > 0
    },
    mallsObj(state) {
      if (!state.malls) {
        return {}
      }
      return state.malls.reduce((n, o) => {
        n[o.provider] = o
        return n
      }, {})
    },
    providersObj(state) {
      if (!state.providers) {
        return {}
      }
      return state.providers.reduce((n, o) => {
        n[o.code] = o
        return n
      }, {})
    },
  },
  mutations: {
    setIsMallsLoad(state, isMallsLoad) {
      state.isMallsLoad = isMallsLoad
    },
    setMalls(state, malls) {
      state.malls = malls
    },
    setProviders(state, providers) {
      state.providers = providers
    },
  },
  actions: {
    async addMalls({}, mall) {
      // v2 로 호출
      const { data } = await defaultV2Api.postMalls(mall)
      return data
    },
    async updateMalls({}, mall) {
      const { data } = await defaultApi.putMalls(mall)
      return data
    },
    async getMallsDetail({}, { uuid }) {
      const { data } = await defaultApi.getMallsDetail({ uuid })
      return data
    },
    async getMalls({ commit, state }) {
      if (getMallsLoading === true) {
        await getMallsLoadingCheck()
        return state.malls
      }
      try {
        getMallsLoading = true
        const {
          data: { results },
        } = await defaultApi.getMalls()
        commit('setMalls', results)
        commit('setIsMallsLoad', true)
        return results
      } finally {
        getMallsLoading = false
      }
    },
    async getMallProviders({ commit, state }) {
      if (getMallsProvidersLoading === true) {
        await getMallsProvidersLoadingCheck()
        return state.providers
      }
      try {
        getMallsProvidersLoading = true
        const {
          data: { results },
        } = await defaultApi.getMallProviders()
        results.forEach((r) => (r.logo404Path = logo404Path))

        // TODO 연동할 플랫폼 정렬 로직 임시
        // 무신사-에이블리-지그재그-브랜디-하이버-비플로우 우선
        const order = ['musinsa', 'ably', 'zigzag', 'wconcept', '29cm', 'brandi', 'hiver', 'brich']
        results.sort(function (a, b) {
          return order.indexOf(a.code) - order.indexOf(b.code)
        })

        commit('setProviders', results)
        return results
      } finally {
        getMallsProvidersLoading = false
      }
    },
  },
}
